// extracted by mini-css-extract-plugin
export default {"clientStrip":"ClientStrip_clientStrip__tqRn6","logoTrack":"ClientStrip_logoTrack__-o7BE","scroll":"ClientStrip_scroll__Xfved","clientLogo":"ClientStrip_clientLogo__0sMaS"};